module.exports = __webpack_public_path__ + "img/selected4-min.93781df9.png";